import { ErrorInfo } from 'react';

export const captureException = (error: unknown, errorInfo: ErrorInfo) => {
  window.Sentry?.captureException(error, {
    extra: { errorInfo },
    tags: {
      module: 'miniappServiceBooking',
      version: process.env.REACT_APP_VERSION,
    },
  });
};
